import React from 'react';
import {
	Document,
	Font,
	Page,
	Text,
	StyleSheet,
	View,
	Image,
} from '@react-pdf/renderer';
import EmptySpace from './Components/EmptySpace'
import {List, ListItem} from './Components/BulletPiontList'
import table_1 from '../../images/ground/count/table_1.png'
import table_2 from '../../images/ground/count/table_2.png'
import table_3 from '../../images/ground/count/table_3.png'
import table_4 from '../../images/ground/count/table_4.png'
import table_5 from '../../images/ground/count/table_5.png'
import logo from '../../images/iek_logo.png'


Font.register({
	family: "Roboto",
	fonts: [
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf", fontWeight: 300 },
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf", fontWeight: 400 },
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf", fontWeight: 500 },
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf", fontWeight: 600 },
	]
});

const styles = StyleSheet.create({
	body: {
		paddingTop: 35,
		paddingBottom: 65,
		paddingHorizontal: 35,
	},
	logo: {
		position: 'absolute',
		top: 0,
		left: 0,
		marginLeft: 12,
		height:30,
		textAlign: 'center',
	},
	colon:{
		marginTop: 6,
		textAlign: 'center',
		fontSize: 12,
		color: 'grey',
		fontFamily: 'Roboto',
		paddingHorizontal: '20%'
	},
	tor:{
		position: 'absolute',
		top: 6,
		right: 12,
		fontSize: 12,
		color: 'grey',
		fontFamily: 'Roboto',
	},
	pageNumber: {
		position: 'absolute',
		bottom: 18,
		right: 48,
		fontSize: 12,
		color: 'grey',
	},

	description: {
		fontSize: 12,
		fontFamily: 'Roboto',
		marginLeft: 12,
	},
	title:{
		fontSize: 16,
		textAlign: 'center',
		fontFamily: 'Roboto',
	},
	subtitle: {
		fontSize: 16,
		textAlign: 'center',
		fontFamily: 'Roboto',
		fontWeight:'bold'
	},
	fw_bold: {
		fontWeight:'bold'
	},
	fw_normal:{
		fontWeight:'normal'
	},
	text:{
		marginHorizontal: 12,
		fontSize: 12,
		textAlign: 'justify',
		fontFamily: 'Roboto',
	},
	formula:{
		textAlign: 'center',
		fontFamily: 'Roboto',
		marginVertical:6
	},
	formula_header:{
		fontSize: 12,
		fontWeight:'normal'
	},
	formula_content:{
		fontSize: 12,
		fontWeight:'bold'
	},
	tableContainer: {
		flexDirection: "row",
		flexWrap: "wrap",
		fontSize:12,
		fontFamily: 'Roboto',
	},
	row: {
		flexDirection: "row",
	},
	big:{
		height:50,
	},
	small:{
		height:30,
	},
	first_table_sell:{
		textAlign: 'center',
		borderLeft:'1px solid #000',
		paddingHorizontal:5,
		paddingTop: 8
	},
	fs_small:{
		fontSize:10,
	},
	image: {
		marginLeft: 12,
		height:350,
		textAlign: 'center',
		objectFit:'contain'
	},
	m12:{
		margin: 12,
	}

})




export default (props) => {
	const {Rn, ro1, ro2, H, Lv, Dv, position, b, LCon, tline, t, kc1, kc2, ki1, ki2, pekv, roc, rv, rline,
		lp, lv, n, r, npred, date, name, address, desc, author, imgData='', climate, ratio, sg} = props

	return (
		<Document>
			<Page style={styles.body} wrap>

				{/*Header*/}
				<View fixed style={{marginBottom: 30}}>
					<View style={{width:'14%'}}>
						<Image style={styles.logo} src={logo}/>
					</View>
					<View style={styles.colon}>
						<Text
							render={({pageNumber}) => pageNumber === 1 ? date : name}
							fixed
						/>
					</View>
					<Text style={styles.tor}
								fixed
					>ИМПУЛЬС 1.0.0</Text>
				</ View>

				{/*Page 1*/}
				<EmptySpace />
				<EmptySpace />
				<EmptySpace />
				<EmptySpace />
				<Text style={{...styles.description, textAlign: 'center'}}>{name}</Text>
				<EmptySpace />
				<Text style={{...styles.text, textAlign: 'center'}}>{address}</Text>
				<EmptySpace />
				<EmptySpace />
				<Text style={{...styles.description, textAlign: 'center'}}>ОТЧЕТ</Text>
				<Text style={{...styles.text, textAlign: 'center'}}>Молниезащита и заземление</Text>
				<Text style={{...styles.text, textAlign: 'center'}}>Расчет заземления</Text>
				<Text break/>

				{/*Page 2*/}
				<Text style={{...styles.subtitle, marginBottom:12}}>1 Описание объекта</Text>
				<Text style={{...styles.text, ...styles.m12}}>Дата: {date}</Text>
				<Text style={{...styles.text, ...styles.m12}}>Объект: {name}</Text>
				<Text style={{...styles.text, ...styles.m12}}>Адрес: {address}</Text>
				<Text style={{...styles.text, ...styles.m12}}>{desc}</Text>
				<Text style={{...styles.text, ...styles.m12}}>Автор: {author}</Text>
				<EmptySpace />
				{imgData ? <Image style={styles.image} src={imgData}/> : null  }
				<EmptySpace />

				<Text break/>

				<Text style={{...styles.subtitle, marginBottom:12}}>2 Исходные данные и результат</Text>
				<EmptySpace />
				<Text style={{...styles.description, marginLeft:24, marginBottom:1, fontSize: 14,}}>Исходные данные:</Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Нормируемое сопротивление заземляющего устройства растеканию тока Rн,  Ом: <span style={{fontWeight:'bold'}}>{Rn}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Климатическая зона: <span style={{fontWeight:'bold'}}>{climate}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Удельное R верхнего слоя грунта ρ1, Ом: <span style={{fontWeight:'bold'}}>{ro1}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Удельное R нижнего слоя грунта ρ2, Ом: <span style={{fontWeight:'bold'}}>{ro2}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Толщина верхнего слоя грунта H, м: <span style={{fontWeight:'bold'}}>{H}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Длина одного вертикального заземлителя L, м: <span style={{fontWeight:'bold'}}>{Lv}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Расположение заземлителей: <span style={{fontWeight:'bold'}}>{position}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Отношение расстояний между вертикальными электродами к их длине: <span style={{fontWeight:'bold'}}>{ratio}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Диаметр вертикального заземлителя d, мм: <span style={{fontWeight:'bold'}}>{Dv}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Сечение горизонтального заземлителя, мм: <span style={{fontWeight:'bold'}}>{sg}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Общая длина соединительной полосы Lсоед, м: <span style={{fontWeight:'bold'}}>{LCon}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Глубина заложения от поверхности земли вертикального заземлителя t, м: <span style={{fontWeight:'bold'}}>{t}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Глубина заложения от поверхности земли горизонтального заземлителя tполосы, м: <span style={{fontWeight:'bold'}}>{tline}</span></Text>
				<EmptySpace />
				<Text style={{...styles.description, marginLeft:24, marginBottom:1, fontSize: 14,}}>Результат:</Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Количество вертикальных заземлителей N, шт: <span style={{fontWeight:'bold'}}>{n}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Длина горизантального заземлителя Lг, (с учетом соединительной полосы) м: <span style={{fontWeight:'bold'}}>{lv}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Общее сопротивление заземляющего устройства Rз, Ом: <span style={{fontWeight:'bold'}}>{r}</span></Text>
				<EmptySpace />
				<Text break/>

				<Text style={{...styles.subtitle, marginBottom:12}}>3 Методика расчета защитного заземления</Text>
				<Text style={{...styles.title, ...styles.fw_bold}}></Text>
				<EmptySpace />
				<Text  style={styles.text}>
					Предполагается,  что  устройство  защитного  заземления  состоит  из вертикальных  заземлителей,
					погруженных  в  неоднородный  грунт,  соединенных  горизонтальным  заземлителем.
				</Text>
				<Text  style={styles.text}>
					Расстояние  между  вертикальными  заземлителями  равно  длине  вертикального  заземлителя.
				</Text>
				<Text  style={styles.text}>
					Вертикальные  заземлители  могут  быть  расположены  в  ряд  или  по  контуру.
				</Text>
				<Text  style={styles.text}>
					Материал  вертикального  заземлителя – Ст. пруток  ГОСТ 2590-88
					(в  расчете  можно  выбрать диаметр от 14 до 30 мм).
				</Text>
				<Text  style={{...styles.text, marginTop:8,  marginLeft:16}}>L - длина  вертикального  заземлителя, м.</Text>
				<Text  style={{...styles.text, marginLeft:16}}>t - заглубление  вертикального  заземлителя, м.</Text>
				<Text  style={{...styles.text, marginBottom:8,  marginLeft:16}}>d - диаметр  вертикального  заземлителя, мм.</Text>
				<Text  style={styles.text}>
					Материал  горизонтального  заземлителя – Ст. полосовая  ГОСТ 103-76
					(в  расчете  можно  выбрать  25х4, 40х4 и 50х5 мм).
				</Text>
				<Text  style={{...styles.text, marginTop:8,  marginLeft:16}}>Lп - длина  горизонтального  заземлителя, м</Text>
				<Text  style={{...styles.text,  marginLeft:16}}>tполосы - заглубление  горизонтального  заземлителя, м.</Text>
				<Text  style={{...styles.text,  marginLeft:16}}>tполосы - заглубление  горизонтального  заземлителя, м.</Text>
				<Text  style={{...styles.text, marginBottom:8,  marginLeft:16}}>ρ1, ρ2 – удельные  сопротивления  верхнего  и  нижнего  слоев
					грунта, Ом·м [1, стр.342,  таблица 25.1].
				</Text>
				<EmptySpace />
				<Text  style={styles.text}>Таблица 1. Удельные электрические сопротивления различных грунтов</Text>
				<View>
					<Image style={{...styles.image, height:240}} src={table_1}/>
				</View>
				<EmptySpace />
				<EmptySpace />
				<Text  style={styles.text}>Kс1, Кс2 – коэффициенты  сезонности</Text>
				<EmptySpace />
				<Text  style={styles.text}>Таблица 2. Коэффициенты сезонности (Кс1, Кс2)</Text>
				<View>
					<Image style={{...styles.image, height:220}} src={table_2}/>
				</View>
				<EmptySpace />
				<Text  style={styles.text}>Нормируемое  значение  сопротивления  заземляющего  устройства - Rн, Ом</Text>
				<Text  style={styles.text}>Коэффициенты  использования  вертикальных  и  горизонтальных  заземлителей – Ки1 Ки2 (+ некоторые значения получены интерполяцией).</Text>
				<EmptySpace />
				<Text  style={styles.text}>Таблица 3. Коэффициенты использования вертикальных заземлителей Ки1 </Text>
				<View>
					<Image style={{...styles.image, height:230}} src={table_3}/>
				</View>
				<EmptySpace />
				<Text  style={styles.text}>Таблица 4. Коэффициенты использования горизонтальных заземлителей Ки2</Text>
				<View>
					<Image style={{...styles.image, height:230}} src={table_4}/>
				</View>
				<EmptySpace />
				<Text  style={styles.text}>Таблица 5. Характеристика климатических зон</Text>
				<View>
					<Image style={{...styles.image, height:200}} src={table_5}/>
				</View>
				<Text break/>

				{/*Page 2*/}
				<Text style={{...styles.subtitle, marginBottom:12}}>4 Формулы</Text>
				<EmptySpace />
				<Text style={{...styles.formula, ...styles.formula_header}}>Эквивалентное  сопротивление  грунта:</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>ρэкв = (ρ1 × ρ2 × L) / (ρ1 × (L – H + tполосы) + ρ2 × (H - tполосы))</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>ρэкв = ({ro1} × {ro2} × {Lv}) / ({ro1} × ({Lv} – {H} + {tline}) + {ro2} × ({H} - {tline})) = {pekv} Ом</Text>
				<Text style={{...styles.formula, ...styles.formula_header}}>Сопротивление  одиночного  вертикального  заземлителя:</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>Rос = (Кс1 × ρэкв / (2 × π × L)) × (ln(2 × L / d) + 0.5 × ln((4 × t + L)/(4 × t – L)))</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>Rос = ({kc1} × {pekv} / (2 × π × {Lv})) × (ln(2 × {Lv} × 1000/ {Dv}) + 0.5 × ln((4 × {t} + {Lv})/(4 × {t} – {Lv}))) = {roc} Ом </Text>
				<Text style={{...styles.formula, ...styles.formula_header}}>Заглубление  стержня:</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>t = (L/2) + tполосы</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>t = ({Lv}/2) + {tline} = {t} м </Text>
				<Text style={{...styles.formula, ...styles.formula_header}}>Ориентировочное  количество  вертикальных  заземлителей:</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>n<Text style={{...styles.formula, fontSize:6}}>предв</Text> = Rос / Rн</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>n<Text style={{...styles.formula, fontSize:6}}>предв</Text> = {roc} / {Rn} = {npred} шт </Text>
				{
					position === 'В ряд'
						?
						<View>
							<Text style={{...styles.formula, ...styles.formula_header}}>Длина  полосы  при  размещении  вертикальных  заземлителей  в  ряд:</Text>
							<Text style={{...styles.formula, ...styles.formula_content}}>Lп = L × (n<Text style={{...styles.formula, fontSize:6}}>предв</Text> - 1) + Lсоед</Text>
							<Text style={{...styles.formula, ...styles.formula_content}}>Lп = {Lv} × ({npred} - 1) + {LCon} = {lp} м </Text>
						</View>
					:
						<View>
							<Text style={{...styles.formula, ...styles.formula_header}}>Длина  полосы  при  размещении  вертикальных  заземлителей  по  контуру:</Text>
							<Text style={{...styles.formula, ...styles.formula_content}}>Lп = L × n<Text style={{...styles.formula, fontSize:6}}>предв</Text> + Lсоед</Text>
							<Text style={{...styles.formula, ...styles.formula_content}}>Lп = {Lv} × {npred} + {LCon} = {lp} м</Text>
						</View>
				}
				<Text style={{...styles.formula, ...styles.formula_header}}>Сопротивление  растеканию  тока  горизонтального  заземлителя:</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>Rп = ((Кс2 × ρэкв) / (2 × π × Lп × Ки2)) × ln((2 × L²п)/(b × tполосы))</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>Rп = (({kc2} × {pekv}) / (2 × π × {lp} × {ki2})) × ln((2 × {lp}²)/({b} × {tline} × 0.001)) = {rline} Ом</Text>
				<Text style={{...styles.formula, ...styles.formula_header}}>Сопротивление  вертикальных  заземлителей  с  учетом  сопротивления  току  горизонтального  заземлителя:</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>Rв = Rп × Rн / (Rп - Rн)</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>Rв = {rline} × {Rn} / ({rline} - {Rn}) = {rv} Ом</Text>
				<Text style={{...styles.formula, ...styles.formula_header}}>Окончательное  количество  заземлителей:</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>N = Rос / (Rв × Ки1)</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>N = {roc} / ({rv} × {ki1}) = {n} шт</Text>
				{
					position === 'В ряд'
						?
						<View>
							<Text style={{...styles.formula, ...styles.formula_header}}>Окончательная длина горизонтального заземлителя  при  размещении  вертикальных  заземлителей  в  ряд:</Text>
							<Text style={{...styles.formula, ...styles.formula_content}}>Lг = L × (N - 1) + Lсоед</Text>
							<Text style={{...styles.formula, ...styles.formula_content}}>Lг = {Lv} × ({n} - 1) + {LCon} = {lv} м </Text>
						</View>
						:
						<View>
							<Text style={{...styles.formula, ...styles.formula_header}}>Окончательная длина горизонтального заземлителя  при  размещении  вертикальных  заземлителей  по  контуру:</Text>
							<Text style={{...styles.formula, ...styles.formula_content}}>Lг = L × N + Lсоед</Text>
							<Text style={{...styles.formula, ...styles.formula_content}}>Lг = {Lv} × {n} + {LCon} = {lv} м</Text>
						</View>
				}
				<Text style={{...styles.formula, ...styles.formula_header}}>Окончательная длина вертикального заземлителя:</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>Rз = ((Rос / ((Kи1 × N)) × Rп) / ((Rос / (Kи1 × N)) + Rп)</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>Rз = (({roc}  / ({ki1} × {n})) × {rline}) / (({roc}  / ({ki1} × {n})) + {rline}) = {r} Ом</Text>

				<Text break/>

				{/*Page 3*/}
				<Text style={{...styles.subtitle, marginBottom:12}}>5 Используемая литература</Text>
				<List>
					<ListItem>Долин П.А. Справочник по технике безопасности. М.: Энергоиздат, 1984.</ListItem>
				</List>


			</Page>
		</Document>)
}





// WEBPACK FOOTER //
// ./src/react/ui/PDFCreation/PDFGrondCountReport.js